import { jsx as _jsx } from "react/jsx-runtime";
import IMG_PLAY from '../../common/images/play.png';
import { getImageSrc } from '../utils/get-image-src';
export default (function (_ref) {
  var className = _ref.className,
    style = _ref.style,
    handleClick = _ref.handleClick;
  return _jsx("span", Object.assign({
    className: "inline-block ".concat(className),
    style: style,
    onClick: handleClick
  }, {
    children: _jsx("img", {
      src: getImageSrc(IMG_PLAY)
    })
  }));
});